



























import Vue, { PropType } from "vue"
import PApplicationThanksModal from "./local/PApplicationThanksModal.vue"
import PSwProjectApplyModal from "./local/PSwProjectApplyModal.vue"
import PFloatingInterestedButton from "./local/PFloatingInterestedButton.vue"
import ButtonFloatingFrame from "~/components/custom/buttonFrame/BottomFloatingFrame.vue"
import RoundFavoriteIconButton from "~/components/custom/favoriteButton/RoundFavoriteIconButton.vue"
import PProjectApplyPanel from "~/components/custom/projectApplyPanel/PProjectApplyPanel.vue"
import { ProjectView, decorateProjectView } from "~/backendApis/viewModel"
import { BackendApi } from "~/backendApis"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"
import { SwProjectView } from "~/backendApis/viewModel/swProject"

interface DataType {
  isVisibleThanksModal: boolean
  // プロジェクト応募処理中であるかどうかを示すフラグ
  isApplying: boolean
  // プロジェクト応募状態（未応募・応募済み）を確認済みであるかどうかを示すフラグ
  isAlreadyCheckedApplyStatus: boolean
  // プロジェクトが応募済みであるかどうかを示すフラグ
  isAlreadyApplied: boolean
  // SWプロジェクトが応募済みであるかどうかを示すフラグ
  isSwProjectAlreadyApplied: boolean
  // SWプロジェクト
  swProject: SwProjectView | null
}

export default Vue.extend({
  components: {
    ButtonFloatingFrame,
    RoundFavoriteIconButton,
    PFloatingInterestedButton,
    PProjectApplyPanel,
    PSwProjectApplyModal,
    PApplicationThanksModal,
  },
  props: {
    project: {
      type: Object as PropType<ProjectView>,
      required: true,
    },
  },
  data(): DataType {
    return {
      isVisibleThanksModal: false,
      isApplying: false,
      isAlreadyCheckedApplyStatus: false,
      isAlreadyApplied: false,
      isSwProjectAlreadyApplied: false,
      swProject: null,
    }
  },
  computed: {
    isUserAppliableForProject(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.PROJECT_APPLY)
    },
    isProjectOpenForApplication(): boolean {
      return decorateProjectView(this.project).isOpenForApplication()
    },
    isShownProjectApplyPanel(): boolean {
      return this.$clStores.projectApplyMessage.getters.isShownProjectApplyPanel
    },
    isVisibleBottonFloatingFrame(): boolean {
      return (
        this.isUserAppliableForProject &&
        this.isProjectOpenForApplication &&
        !this.isShownProjectApplyPanel
      )
    },
    isFavorited(): boolean {
      return this.$clStores.favoriteProjectList.getters.isFavorited(
        this.project.id
      )
    },
    applyMessage(): string {
      return this.$clStores.projectApplyMessage.getters.applyMessage
    },
    isSwCorporation(): boolean {
      return this.$clStores.swCorporationAccount.getters.isSwCorporationAccount(
        this.project.universalCorporationId
      )
    },
    isSwProject(): boolean {
      // SW案件情報が取得できなかった場合、通常のプロジェクトとして扱う
      return !!this.swProject && this.isSwCorporation
    },
  },
  async created() {
    const userProfile = await new BackendApi.User.UserProfileSearch.GetCurrentUserProfileReadRequest().get()
    const cnt = userProfile?.selfIntroduction?.length ?? 0
    this.$clStores.projectApplyMessage.actions.updateIsApplicable(cnt >= 100)

    if (this.isSwCorporation) {
      try {
        this.swProject = await this.$clApi.main.user.project.read.showSwProject(
          {
            projectId: this.project.id,
          }
        )

        const swProjectApplication = await this.$clApi.main.user.swProjectApplication.read.getSwProjectApplicationForUser(
          {
            projectId: this.project.id,
          }
        )

        // SWプロジェクト応募情報を取得できた場合、応募済みフラグを立てる
        if (swProjectApplication) {
          this.isSwProjectAlreadyApplied = true
        }

        // SWプロジェクトの場合は、応募済みでもボタンを非活性にしない
        // (通常のプロジェクトとは異なり、SWプロジェクトはSWページへ遷移させる)

        this.isAlreadyCheckedApplyStatus = true
      } catch (e) {
        if (e.statusCode !== 404) {
          throw e
        }
      }
    }

    const projectApplication = await new BackendApi.User.Matching.GetProjectApplicationReadRequest(
      {
        projectId: this.project.id,
      }
    ).get()

    // プロジェクト応募情報を取得できた場合、応募状態を応募済みにする
    if (projectApplication) {
      this.updateApplyStatusToAlreadyApplied()
    }

    this.isAlreadyCheckedApplyStatus = true
  },
  beforeMount() {
    this.$clStores.projectApplyMessage.actions.closeProjectApplyPanel()
    this.$clStores.projectApplyMessage.actions.initializeStateForNewProject(
      this.project.id
    )
    this.$clStores.favoriteProjectList.actions.refreshList()
  },
  methods: {
    openProjectApply() {
      if (this.isSwProject) {
        this.$clStores.projectApplyMessage.actions.openSwProjectApplyModal()
        return
      }

      this.$clStores.projectApplyMessage.actions.openProjectApplyPanel()
    },
    openProjectApplyPanel() {
      this.$clStores.projectApplyMessage.actions.openProjectApplyPanel()
    },
    closeProjectApplyPanel() {
      this.$clStores.projectApplyMessage.actions.closeProjectApplyPanel()
    },
    openSwProjectApplyModal() {
      this.$clStores.projectApplyMessage.actions.openSwProjectApplyModal()
    },
    closeSwProjectApplyModal() {
      this.$clStores.projectApplyMessage.actions.closeSwProjectApplyModal()
    },
    openThanksModal() {
      this.isVisibleThanksModal = true
    },
    hideThanksModal() {
      this.isVisibleThanksModal = false
    },
    updateApplyStatusToAlreadyApplied() {
      this.isAlreadyApplied = true
    },
    toggleFavoriteStatus() {
      this.$gtag("event", "click_project_favorite", {
        projectId: this.project.id,
        isFavorited: !this.isFavorited,
      })
      this.$clStores.favoriteProjectList.actions.toggleFavoriteStatus(
        this.project.id
      )
    },
    async apply() {
      if (!this.applyMessage) {
        this.$clStores.flashMessage.actions.drawFlashError(
          " 応募メッセージを入力してください"
        )
        return
      }

      const applicationMessage =
        "\n以下のプロジェクトについてお話をお聞きしたいです。\n\n" +
        `${this.project.title || ""}\n` +
        `${process.env.SERVICE_BASE_URL}/projects/${this.project.id}\n\n` +
        "プロフィール\n" +
        `${process.env.SERVICE_BASE_URL}/profiles/${this.$clAuth.userIdOrFail}\n\n` +
        this.applyMessage

      if (applicationMessage.length >= 1000) {
        this.$clStores.flashMessage.actions.drawFlashError(
          " 応募メッセージの文字数を750文字以下にしてから送信ください。"
        )
        return
      }

      this.isApplying = true
      this.$gtag("event", "application_project", {
        project_id: this.project.id,
        message_length: applicationMessage.length,
      })
      await new BackendApi.User.Matching.ApplyForProjectWriteRequest({
        projectId: this.project.id,
        applicationMessage,
      })
        .post()
        .catch((e) => {
          alert(
            "応募に失敗しました。再度お試しいただくか、お時間を空けてから再度お試しください。"
          )
          this.isApplying = false
          throw e
        })
      this.updateApplyStatusToAlreadyApplied()
      this.closeProjectApplyPanel()
      this.openThanksModal()
    },
    async swApply() {
      this.isApplying = true
      try {
        const swUserProfile = await this.$clApi.main.user.swUserProfile.read.getSwUserProfile(
          {
            projectId: this.project.id,
          }
        )

        try {
          await this.$clApi.swApi.createSwAccount(swUserProfile)
        } catch (e) {
          /**
           * SW側のサーバーがダウンしている場合のエラーを出力するようにする
           * SW側のサーバー内でエラーが発生した場合は、SW側でエラーページの表示などをしてもらう
           */
          this.$clStores.flashMessage.actions.drawFlashError(
            "SWアカウントの作成に失敗しました。"
          )
          throw e
        }

        // すでに応募済みの場合は、応募リクエストをスキップ
        if (!this.isSwProjectAlreadyApplied) {
          await this.$clApi.main.user.swProjectApplication.write.applyForSwProject(
            {
              projectId: this.project.id,
            }
          )
          // 応募成功後、応募済みフラグを立てる
          this.isSwProjectAlreadyApplied = true
        }
        // SWプロジェクトの場合は、応募後もボタンを非活性にしない
        // (SWページへの遷移を可能にするため)
      } catch (e) {
        if (e.statusCode !== 404) {
          throw e
        }
        this.$clStores.flashMessage.actions.drawFlashError(
          "SWプロジェクトへの応募に失敗しました。"
        )
      } finally {
        this.isApplying = false

        this.closeSwProjectApplyModal()
      }
    },
  },
})
